import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { JsonProperty, JsonObject } from 'json2typescript';
import { EmptyControl, HvlQueryModel, Required } from '@hvlng/framework-bff/core';
import { CodeTextDiscriminatorModel, TimeConstrainedBaseQueryModel } from 'humanresources-common-shared';

@JsonObject('KovanHrPositionQueryModel')
export class PositionQueryModel extends TimeConstrainedBaseQueryModel {
    @EmptyControl()
    @JsonProperty('managerialPosition', Boolean, true)
    managerialPosition: boolean = null;

    @EmptyControl()
    @JsonProperty('perObjectDefinitionId', Number, true)
    perObjectDefinitionId: number = null;

    @EmptyControl()
    @JsonProperty('objectNumber', String, true)
    objectNumber: string = null;

    @EmptyControl()
    @JsonProperty('objectCode', String, true)
    objectCode: string = null;

    @EmptyControl()
    @JsonProperty('position', String, true)
    position: string = null;

    @EmptyControl()
    @JsonProperty('objectStatusId', Number, true)
    objectStatusId: number = null;

    @EmptyControl()
    @JsonProperty('showEmptyPosition', Boolean, true)
    showEmptyPosition: boolean = null;

    @EmptyControl()
    @JsonProperty('objectStatus', CodeTextDiscriminatorModel, true)
    objectStatus: CodeTextDiscriminatorModel = null;

    @EmptyControl()
    @JsonProperty('activeRecord', Boolean, true)
    activeRecord: boolean = null;

    @EmptyControl()
    @JsonProperty('serviceClassId', Number, true)
    serviceClassId: number = null;

    @EmptyControl()
    @JsonProperty('degreeOfCadree', Number, true)
    degreeOfCadree: number = null;

    @EmptyControl()
    @JsonProperty('staffFullnessStatus', String, true)
    staffFullnessStatus: string = null;

    @EmptyControl()
    @JsonProperty('notIncludedCapacity', Boolean, true)
    notIncludedCapacity: boolean = null;
    @EmptyControl()
    @JsonProperty('date', HvlDateConverter, true)
    date: Date = null;
}
